/**
 * 화장품 이미지 분석 관련 타입 정의
 */
import { normalizeProductType } from './sampleRequest.types';

export interface CosmeticAnalysisRequest {
  image_url: string;
  additional_context?: string;
}

export interface CosmeticAnalysisResponse {
  is_cosmetic: boolean;
  // Product Information
  suggested_product_name: string;
  product_type: string;
  volume: string;
  // Formula & Ingredients
  efficacy_function: string;
  formula_texture: string;
  key_ingredients: string;
  restricted_ingredients: string;
  // Marketing & Claims
  marketing_claims: string;
  fragrance: string;
  color: string;
  // Packaging
  primary_packaging: string;
  secondary_packaging: string;
  // Market
  target_market_country: string;
  // Meta
  confidence_score: number;
  analysis_time_ms: number;
}

export interface CosmeticAnalysisError {
  reason: string;
}

// 분석 결과 폼 표시용 공통 필드 (CosmeticAnalysisResponse / CosmeticAnalysisHistoryItem 공통 부분집합)
export interface CosmeticAnalysisFields {
  suggested_product_name: string;
  product_type: string;
  volume: string;
  efficacy_function: string;
  formula_texture: string;
  key_ingredients: string;
  restricted_ingredients: string;
  marketing_claims: string;
  fragrance: string;
  color: string;
  primary_packaging: string;
  secondary_packaging: string;
  target_market_country: string;
}

// 저장된 분석 이력 항목 (백엔드 CosmeticAnalysisHistoryDto - snake_case)
export interface CosmeticAnalysisHistoryItem {
  id: number;
  image_url: string;
  source: 'brand' | 'admin';
  brand_id: number | null;
  admin_id: number | null;
  brand_company_name?: string | null;
  admin_name?: string | null;
  additional_context: string;
  // Product Information
  suggested_product_name: string;
  product_type: string;
  volume: string;
  // Formula & Ingredients
  efficacy_function: string;
  formula_texture: string;
  key_ingredients: string;
  restricted_ingredients: string;
  // Marketing & Claims
  marketing_claims: string;
  fragrance: string;
  color: string;
  // Packaging
  primary_packaging: string;
  secondary_packaging: string;
  // Market
  target_market_country: string;
  // Meta
  confidence_score: number;
  analysis_time_ms: number;
  created_at: string;
}

// Spring Data Page 응답 (camelCase 직렬화)
export interface CosmeticAnalysisHistoryPage {
  content: CosmeticAnalysisHistoryItem[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
  first: boolean;
  last: boolean;
}

// Sample Request 필드 매핑 (snake_case - sampleFormData와 일치)
export const mapToSampleRequestFields = (analysis: CosmeticAnalysisResponse) => ({
  product_name: analysis.suggested_product_name,
  product_type: normalizeProductType(analysis.product_type),
  volume: analysis.volume,
  efficacy_function: analysis.efficacy_function,
  formula_texture: analysis.formula_texture,
  key_promotional_ingredients: analysis.key_ingredients,
  restricted_ingredients: analysis.restricted_ingredients,
  marketing_brand_claims: analysis.marketing_claims,
  fragrance: analysis.fragrance,
  color: analysis.color,
  primary_packaging: analysis.primary_packaging,
  secondary_packaging: analysis.secondary_packaging,
  target_market_country: analysis.target_market_country,
});
